import { Typography, type TypographyProps } from "@mui/material";
import type { FC } from "react";

export const SnackbarSubHeader: FC<TypographyProps> = ({ children }) => (
	<Typography variant="body1" fontSize="1.75rem" lineHeight="3rem" marginBottom={0}>
		{children}
	</Typography>
);
